import _asyncToGenerator from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/regenerator/index.js";
import React, { useEffect, useState, useContext } from 'react';
import { Box, Container, Grid, SvgIcon, useMediaQuery } from '@mui/material';
import { TAGDialog, TAGDialogActions, TAGDialogContent, TAGDialogTitle, TAGPhoneDrawer, TAGTypography } from '../elements';
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import TAGButton from '../elements/TAGButton/TAGButton';
import Divider from '@mui/material/Divider';
import { useTheme } from '@mui/material/styles';
import { AppContext } from '../../contexts';

var Rating = function Rating(_ref) {
  var rating = _ref.rating;
  var str = rating.toString();
  var arr = str.split('.');
  var full = arr[0];
  var half = arr[1];

  if (half >= 6) {
    full++;
  }

  return React.createElement(Box, {
    style: {
      display: 'flex',
      marginRight: '8px'
    }
  }, _toConsumableArray(Array(+full)).map(function (_, i) {
    return React.createElement(Box, {
      key: i,
      sx: {
        color: 'warning.dark'
      }
    }, React.createElement(SvgIcon, null, React.createElement(StarIcon, null)));
  }), half > 2 && half < 6 && React.createElement(Box, {
    sx: {
      color: 'warning.dark'
    }
  }, React.createElement(SvgIcon, null, React.createElement(StarHalfIcon, null))));
};

var OneReview = function OneReview(_ref2) {
  var _review$comments;

  var review = _ref2.review,
      sx = _ref2.sx;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      full = _useState2[0],
      setFull = _useState2[1];

  var theme = useTheme();
  var mobileWidth = useMediaQuery(theme.breakpoints.down('md'));

  var getShortText = function getShortText(text) {
    if (text && text.length >= 150) {
      var _text$slice;

      var truncate = ((_text$slice = text.slice) === null || _text$slice === void 0 ? void 0 : _text$slice.call(text, 0, 150).trim()) + '.... ';
      return truncate;
    }

    return text;
  };

  var fullText = review === null || review === void 0 ? void 0 : review.comments;
  var shortText = getShortText(fullText);
  return React.createElement(React.Fragment, null, React.createElement(Grid, {
    sx: sx
  }, React.createElement(Box, {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  }, React.createElement(Box, {
    sx: {
      marginBottom: '11px'
    }
  }, React.createElement(Rating, {
    rating: review === null || review === void 0 ? void 0 : review.rating
  })), React.createElement(TAGTypography, {
    variant: mobileWidth ? 'bodyMediumBook' : 'bodyLargeBook',
    color: "text.secondary"
  }, !full ? shortText : fullText, !full && (review === null || review === void 0 ? void 0 : (_review$comments = review.comments) === null || _review$comments === void 0 ? void 0 : _review$comments.length) > 150 && React.createElement(TAGTypography, {
    variant: mobileWidth ? 'bodyMediumBook' : 'bodyLargeBook',
    color: "text.link",
    sx: {
      cursor: 'pointer',
      textDecoration: 'underline'
    },
    onClick: function onClick() {
      return setFull(true);
    }
  }, "Read more")), React.createElement(TAGTypography, {
    variant: "bodyMediumBook",
    color: "text.secondary",
    margin: "10px 0"
  }, "Posted on: ", review === null || review === void 0 ? void 0 : review.sourceType), React.createElement(TAGTypography, {
    variant: "bodyMediumBook",
    color: "text.secondary",
    margin: "-8px 0"
  }, review === null || review === void 0 ? void 0 : review.reviewDate))), React.createElement(Divider, {
    sx: {
      margin: '20px 0 10px'
    }
  }));
};

var ReviewsModal = function ReviewsModal(_ref3) {
  var _data$facility, _data$facility2, _data$facility3, _data$reviews, _data$facility4, _data$reviews2;

  var businessId = _ref3.businessId;
  var environment = process.env.NODE_ENV === 'development' ? 'nonprod' : 'prod';

  var _useContext = useContext(AppContext),
      config = _useContext.state.config;

  var theme = useTheme();
  var mobileWidth = useMediaQuery(theme.breakpoints.down('md'));

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      data = _useState6[0],
      setData = _useState6[1];

  var toggleOpen = function toggleOpen() {
    setOpen(!open);
  };

  var facilityURL = "".concat(config === null || config === void 0 ? void 0 : config[environment].REVIEWS_FACILITY_API_URL).concat(businessId).concat(config === null || config === void 0 ? void 0 : config[environment].REVIEWS_API_KEY);
  var reviewsURL = "".concat(config === null || config === void 0 ? void 0 : config[environment].REVIEWS_API_URL).concat(businessId).concat(config === null || config === void 0 ? void 0 : config[environment].REVIEWS_API_KEY);
  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var results, r, rev, rr, filteredReviews;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(facilityURL, {
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                  }
                });

              case 2:
                results = _context.sent;
                _context.next = 5;
                return results.json();

              case 5:
                r = _context.sent;
                _context.next = 8;
                return fetch(reviewsURL, {
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                  }
                });

              case 8:
                rev = _context.sent;
                _context.next = 11;
                return rev.json();

              case 11:
                rr = _context.sent;
                filteredReviews = rr.filter(function (rev) {
                  return rev.comments != null;
                });
                setData({
                  facility: r,
                  reviews: filteredReviews
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchData() {
        return _ref4.apply(this, arguments);
      };
    }();

    fetchData();
  }, []);
  return React.createElement(React.Fragment, null, data.facility && React.createElement(Grid, {
    display: 'flex',
    alignItems: 'center'
  }, React.createElement(Rating, {
    rating: data === null || data === void 0 ? void 0 : (_data$facility = data.facility) === null || _data$facility === void 0 ? void 0 : _data$facility.avgRating
  }), React.createElement(TAGButton, {
    onClick: toggleOpen
  }, (data === null || data === void 0 ? void 0 : (_data$facility2 = data.facility) === null || _data$facility2 === void 0 ? void 0 : _data$facility2.reviewCount) + ' reviews')), mobileWidth ? React.createElement(TAGPhoneDrawer, {
    open: open,
    onOpen: toggleOpen,
    onClose: toggleOpen,
    swipeAreaWidth: 56
  }, React.createElement(Container, null, React.createElement(TAGTypography, {
    variant: "h2",
    sx: {
      marginTop: '40px',
      marginBottom: '15px'
    }
  }, data === null || data === void 0 ? void 0 : (_data$facility3 = data.facility) === null || _data$facility3 === void 0 ? void 0 : _data$facility3.alias), data === null || data === void 0 ? void 0 : (_data$reviews = data.reviews) === null || _data$reviews === void 0 ? void 0 : _data$reviews.map(function (review) {
    return React.createElement(OneReview, {
      key: review.reviewId,
      review: review,
      sx: {
        marginRight: '45px'
      }
    });
  }))) : React.createElement(TAGDialog, {
    handleClose: toggleOpen,
    open: open,
    sx: {
      '.MuiGrid-root': {
        position: 'static'
      },
      '.MuiPaper-root': {
        width: '620px',
        height: '420px'
      }
    }
  }, React.createElement(TAGDialogTitle, null, data === null || data === void 0 ? void 0 : (_data$facility4 = data.facility) === null || _data$facility4 === void 0 ? void 0 : _data$facility4.alias), React.createElement(TAGDialogContent, null, data === null || data === void 0 ? void 0 : (_data$reviews2 = data.reviews) === null || _data$reviews2 === void 0 ? void 0 : _data$reviews2.map(function (review) {
    return React.createElement(OneReview, {
      key: review.reviewId,
      review: review
    });
  })), React.createElement(TAGDialogActions, null, React.createElement(TAGButton, {
    variant: "text",
    size: "small",
    buttonVariant: "Primary Accent01",
    color: "accent01",
    onClick: function onClick() {
      return setOpen(false);
    }
  }, "Close"))));
};

export default ReviewsModal;